(function ($) {
  'use strict';

  // search toggle
  function searchFunction(){
    var $toggleSearch = $('.toggle-search, #search-overlay'),
    $searchOverlay = $('#search-overlay'),
    $searchElm = $('.search-field, .search-button, .loupe');

    $toggleSearch.on('click', function(e){
      e.stopPropagation();
      $searchOverlay.fadeToggle(200);
    });

    $searchElm.on('click', function(e){
      e.stopPropagation();
    });
  }

  // faq toggler
  function faqToggle(){
    if($('.faq-item').length > 0){
        var $faqItem = $('.faq-item .post-content .wrapper');

        $faqItem.on('click', function(){
          if(!$(this).hasClass('active')){
            $faqItem.removeClass('active').next().slideUp(250);
            $(this).addClass('active').next().slideToggle(250);
          } else {
            $(this).removeClass('active').next().slideToggle(250);
          }
        });
    }
  }

  //accordion toggle 
  function accordionToggle(){
    if($('.accordion-wrapper').length > 0){
        var $accordionItem = $('.accordion-wrapper .post-content-wrapper .inside-wrapper');

        $accordionItem.on('click', function(){
          if(!$(this).hasClass('open')){
            $accordionItem.removeClass('open').next().slideUp(250);
            $(this).addClass('open').next().slideToggle(250);
          } else {
            $(this).removeClass('open').next().slideToggle(250);
          }
        });
    }
  }

  // auto next input field on type
  function nextField(){
    $("#big-login-form input").keyup(function () {
      if (this.value.length == this.maxLength) {
        $(this).next('input').focus();
      }
    });
  }

  function videoEngage(){
    var tag = document.createElement('script');
    tag.src = "//cdnmc1.vod309.com/multichannel/veeva/js/engage/embed-engage.js";
    var engage = document.getElementById('engage');
    engage.parentNode.insertBefore(tag, engage.nextSibling);

    var player;
    function onVeevaEngageReady() {
        player = new VeevaEngage.initialize('engage', {
             dns: '//cdnmc1.vod309.com/multichannel/release/engage/index.html',
             mc: 'https://mc1.vod309.com/multichannel',
             cookie_error: 'Please allow cookies in order to view presentation.',
             width: '100%',
             height: '100%'
        });
    }
  }


  $( document ).ready(function() {
    searchFunction();
    faqToggle();
    nextField();
    accordionToggle();
    // videoEngage();
  });

  // var $navItems = $('#main-nav li');
  // var $navItem = $('#main-nav a');

  // $navItem.on('click', function(e){
  // 	if($(this).parent().hasClass('active')){
  // 		e.preventDefault();
  // 		$navItems.removeClass('active');
  // 	} else {
  // 		$navItems.removeClass('active');
  // 		if($(this).siblings().size() > 0){
  // 			e.preventDefault();
  // 			$(this).parent().toggleClass('active');
  // 		} else {
  // 			$(this).parent().toggleClass('active');
  // 		}
  // 	}
  // });
}(jQuery));
